module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am369-2cf4d9148cf147ac5d5e89ccde15ed16.jpg";